import React from 'react';
import styled from "styled-components";
import ButtonTransparent from "./button.transparent";
import BookmarkOutlineIcon from '@icons/bookmark.svg';
import Icon from "./icon";

function BookmarkButton({className, width, height, onClick}) {
    return (
        <Container onClick={onClick} className={'bookmark ' + (className ? className : '')}>
            <Icon width={width ?? "24"} height={(height ?? "24")}>
                <BookmarkOutlineIcon/>
            </Icon>
        </Container>
    )
}

export default React.memo(BookmarkButton);

const Container = styled(ButtonTransparent)`
    &.active {
        svg {
            path, polygon {
                fill: #ef394e;
                stroke: #ef394e;
            }
        }
    }
`;